module.exports = __webpack_public_path__ + "static/media/image_15.d6b8a69c.png";